import { render, staticRenderFns } from "./editMenu.vue?vue&type=template&id=708fcb0c&scoped=true&"
import script from "./editMenu.vue?vue&type=script&lang=js&"
export * from "./editMenu.vue?vue&type=script&lang=js&"
import style0 from "./editMenu.vue?vue&type=style&index=0&id=708fcb0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708fcb0c",
  null
  
)

export default component.exports